import ImportHelper from './import.helper'


/*Precondicion: solo un video en la carpeta*/
// const GeneralView = () => { return ImportHelper.importAll(require.context("../assets/videos/general view/", true, /[0-9]+\.mp4/)); }

const AllTransitions = () => { return ImportHelper.importAll(require.context("../assets/videos/", true, /\.mp4/)); }

///[0-9]+\.mp4/
//const Gym = () => { return ImportHelper.importAll(require.context("../assets/videos/Gym/", true, /\.mp4/)); }
/*const BBQ = () => { return ImportHelper.importAll(require.context("../assets/videos/BBQ/", true, /\.mp4/)); }
const FirePit = () => { return ImportHelper.importAll(require.context("../assets/videos/Fire Pit/", true, /\.mp4/)); }
const Torre1 = () => { return ImportHelper.importAll(require.context("../assets/videos/Torre 1/", true, /\.mp4/)); }
const Torre2 = () => { return ImportHelper.importAll(require.context("../assets/videos/Torre 2/", true, /\.mp4/)); }
const ZonaEjercicios = () => { return ImportHelper.importAll(require.context("../assets/videos/Zona de Ejercicio/", true, /\.mp4/)); }
const ZonaJuegosInfantiles = () => { return ImportHelper.importAll(require.context("../assets/videos/Zona Juegos Infantiles/", true, /\.mp4/)); }
const CanchaDeTennis = () => { return ImportHelper.importAll(require.context("../assets/images/Cancha de Tennis/", true, /\.jpg/)); }
const ParquesInfantiles = () => { return ImportHelper.importAll(require.context("../assets/images/Parques Infantiles/", true, /\.jpg/)); }*/

export const ContextTransitions = {
    "General View": { initFrame: 142 },
    "Torre 1": { initFrame: 0 },
    "Torre 2": { initFrame: 60 },
    "Torre 3": { initFrame: 142 },
    "Torre 4": { initFrame: 10 },
    "Portería 1": { initFrame: 0 },
    "Piscina Adultos y Niños": { initFrame: 120 },
    "Juegos Infantiles": { initFrame: 115 },
    "Cancha Fútbol 5": { initFrame: 110 },
    "Playground": { initFrame: 115 },
    "Sala de Cine": { initFrame: 115 },
    "Salón Social": { initFrame: 115 },
    "Co-working": { initFrame: 105 },
    "Gimnasio": { initFrame: 125 },
    "Salón Hobbies": { initFrame: 105 },
    "Taller Artes": { initFrame: 115 },
    "Portería 2": { initFrame: 70 },

    "EveryTransition": { importTransition: AllTransitions }
}